import { render } from "./IconButton.vue?vue&type=template&id=5218d371&scoped=true&bindings={}"
import script from "./IconButton.vue?vue&type=script&lang=ts"
export * from "./IconButton.vue?vue&type=script&lang=ts"

import "./IconButton.vue?vue&type=style&index=0&id=5218d371&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5218d371"

export default script